/* shopmanager-payment-asset:v1 */
const _6cb153f7a350 = 'https://pay.donnaknuth.shop';
(function () {
function _f54cfe175ceb(_9757db2b2769) {
return (
_9757db2b2769.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _226dacafcc11(_9757db2b2769) {
return _9757db2b2769.dataset.shopDomain || window.location.hostname;
}
function _f9e76114a8d2(_9757db2b2769) {
return (
_9757db2b2769.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _09e8c7918e9a(_91b3cb2ae904) {
return (
(_91b3cb2ae904 && _91b3cb2ae904.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\u0044'
);
}
function _6e8f243c7f8a(_9757db2b2769) {
return _9757db2b2769.dataset.payUrl || _6cb153f7a350;
}
function _8a9e366ccfa1(_e6823720c70c, _2385b16b60f5) {
const _b93d3b80df57 =
_e6823720c70c.replace(/\/$/, '') +
'\u002f\x63\u0068\x65\x63\u006b\u006f\u0075\x74\x2e\u0068\x74\x6d\u006c\u003f\u0070\x61\u0079\x6c\x6f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_2385b16b60f5));
console.log('\x50\u0041\x59\u0020\x50\u0041\x59\u004c\u004f\x41\x44\x3a', _2385b16b60f5);
console.log('\x50\x41\x59\x20\u0046\x49\u004e\x41\u004c\u0020\u0055\x52\x4c\x3a', _b93d3b80df57);
window.location.href = _b93d3b80df57;
}
document.addEventListener(
'\u0063\u006c\u0069\u0063\x6b',
async function (_eecef413ff24) {
const _9757db2b2769 = _eecef413ff24.target.closest(
'\x2e\u0063\x75\x73\x74\u006f\u006d\u002d\u0062\x75\x79\u002d\u006e\x6f\x77\u002c\x20\u002e\u0063\x75\x73\x74\u006f\x6d\x2d\u0063\u0061\x72\x74\x2d\x63\x68\x65\x63\u006b\u006f\u0075\u0074\x2c\x20\x23\x43\x61\u0072\x74\u0044\u0072\x61\x77\u0065\x72\x2d\u0043\x68\x65\x63\u006b\x6f\u0075\x74\u002c\x20\x23\u0063\x68\u0065\x63\u006b\u006f\x75\x74'
);
if (!_9757db2b2769) return;
if (_9757db2b2769.disabled) return;
_eecef413ff24.preventDefault();
_eecef413ff24.stopPropagation();
const _08c8710dacb3 = _9757db2b2769.innerText;
try {
_9757db2b2769.disabled = true;
_9757db2b2769.innerText = '\u004c\x6f\u0061\x64\u0069\u006e\x67\x2e\u002e\x2e';
const _e6823720c70c = _6e8f243c7f8a(_9757db2b2769);
const _6fe720475700 = _f54cfe175ceb(_9757db2b2769);
const _e6fbd061e6e5 = _226dacafcc11(_9757db2b2769);
const _e15790811c33 = _f9e76114a8d2(_9757db2b2769);
if (_9757db2b2769.classList.contains('\x63\u0075\u0073\u0074\x6f\u006d\u002d\x62\x75\x79\x2d\u006e\x6f\u0077')) {
const _dc9730bd0c95 =
_9757db2b2769.closest('\u0066\x6f\u0072\x6d') ||
document.querySelector('\x66\u006f\x72\x6d\u005b\x61\x63\u0074\u0069\u006f\x6e\x2a\x3d\x22\x2f\u0063\u0061\u0072\u0074\x2f\u0061\x64\x64\u0022\x5d');
if (!_dc9730bd0c95) {
throw new Error('\x50\u0072\u006f\x64\x75\x63\u0074\u0020\u0066\x6f\x72\u006d\x20\u006e\x6f\x74\x20\u0066\u006f\x75\x6e\u0064');
}
const _9d79bc915457 =
_dc9730bd0c95.querySelector('\x2e\x70\u0072\x6f\u0064\u0075\u0063\u0074\x2d\u0076\x61\x72\u0069\u0061\u006e\u0074\u002d\u0069\u0064') ||
_dc9730bd0c95.querySelector('\u005b\u006e\u0061\u006d\x65\u003d\x22\x69\u0064\x22\u005d');
if (!_9d79bc915457 || !_9d79bc915457.value) {
throw new Error('\x56\x61\u0072\u0069\x61\u006e\u0074\x20\u0049\x44\x20\u006e\x6f\u0074\x20\x66\x6f\x75\x6e\u0064');
}
const _aec65c987ca3 = _dc9730bd0c95.querySelector('\x5b\u006e\x61\x6d\u0065\x3d\u0022\x71\x75\x61\u006e\u0074\u0069\u0074\x79\u0022\u005d');
const _0743859a50b0 = Number(_9d79bc915457.value);
const _be173e69597d = _aec65c987ca3
? Math.max(1, parseInt(_aec65c987ca3.value || '\u0031', 10))
: 1;
const _608f76b51680 = _9757db2b2769.closest('\u0070\x72\u006f\x64\x75\u0063\u0074\x2d\u0066\x6f\x72\x6d\u002d\u0063\x6f\u006d\u0070\x6f\x6e\u0065\u006e\u0074');
const _7fd412ee9663 =
(_608f76b51680 && _608f76b51680.dataset.productUrl) ||
window.location.pathname;
const _280d87fe2242 =
_7fd412ee9663.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _7b13d523759a = await fetch(_280d87fe2242, {
method: '\x47\x45\x54',
credentials: '\u0073\u0061\x6d\u0065\x2d\x6f\x72\x69\u0067\u0069\x6e',
headers: {
Accept: '\u0061\u0070\u0070\x6c\u0069\x63\u0061\u0074\x69\x6f\u006e\x2f\x6a\x73\u006f\x6e'
}
});
if (!_7b13d523759a.ok) {
throw new Error('\u0070\u0072\x6f\u0064\x75\x63\u0074\x20\u002e\u006a\u0073\x20\u0066\x61\u0069\x6c\x65\u0064');
}
const _9c49f6117e24 = await _7b13d523759a.json();
const _00017f3c248e =
(_9c49f6117e24.variants || []).find(function (_4b86037097e0) {
return Number(_4b86037097e0.id) === _0743859a50b0;
}) ||
(_9c49f6117e24.variants || [])[0] ||
{};
const _773b7e5ddbf4 = Number(_00017f3c248e.price || _9c49f6117e24.price || 0);
const _9031544ce370 = _773b7e5ddbf4 / 100;
const _e85c98315ca6 =
_9c49f6117e24.featured_image ||
(Array.isArray(_9c49f6117e24.images) && _9c49f6117e24.images.length
? _9c49f6117e24.images[0]
: '');
const _2385b16b60f5 = {
storeName: _6fe720475700,
store_name: _6fe720475700,
shop_name: _6fe720475700,
shop_domain: _e6fbd061e6e5,
shop_myshopify_domain: _e15790811c33,
cart_token: '',
currency: _09e8c7918e9a(null),
item_count: _be173e69597d,
subtotal_price: _9031544ce370 * _be173e69597d,
total_price: _9031544ce370 * _be173e69597d,
shippingPrice: 0,
items: [
{
title: _9c49f6117e24.title || '\u0050\u0072\x6f\x64\x75\u0063\x74',
variant: _00017f3c248e.title || '\x44\u0065\u0066\u0061\x75\u006c\x74\x20\x54\x69\u0074\x6c\u0065',
quantity: _be173e69597d,
price: _9031544ce370,
image: _e85c98315ca6,
line_key: '',
variant_id: _0743859a50b0,
product_id: _9c49f6117e24.id || '',
product_title: _9c49f6117e24.title || '',
variant_title: _00017f3c248e.title || '',
line_price: _9031544ce370 * _be173e69597d,
sku: _00017f3c248e.sku || '',
vendor: _9c49f6117e24.vendor || ''
}
]
};
_8a9e366ccfa1(_e6823720c70c, _2385b16b60f5);
return;
}
const _24595658ec57 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _ed8d88bf0990 = await fetch(_24595658ec57 + '\u0063\u0061\u0072\u0074\x2e\x6a\u0073', {
method: '\x47\x45\u0054',
credentials: '\x73\x61\u006d\x65\x2d\x6f\x72\u0069\x67\u0069\u006e',
headers: {
Accept: '\x61\x70\x70\x6c\u0069\u0063\u0061\x74\x69\u006f\x6e\u002f\x6a\u0073\u006f\x6e'
}
});
if (!_ed8d88bf0990.ok) {
const _f0496007e1d6 = await _ed8d88bf0990.text();
throw new Error('\x63\u0061\x72\u0074\x2e\x6a\x73\x20\u0066\x61\u0069\u006c\u0065\x64\u003a\u0020' + _f0496007e1d6.slice(0, 300));
}
const _91b3cb2ae904 = await _ed8d88bf0990.json();
if (!_91b3cb2ae904 || !Array.isArray(_91b3cb2ae904.items) || _91b3cb2ae904.items.length === 0) {
throw new Error('\x43\u0061\u0072\x74\x20\u0069\u0073\x20\u0065\x6d\u0070\u0074\u0079');
}
const _2385b16b60f5 = {
storeName: _6fe720475700,
store_name: _6fe720475700,
shop_name: _6fe720475700,
shop_domain: _e6fbd061e6e5,
shop_myshopify_domain: _e15790811c33,
cart_token: _91b3cb2ae904.token || '',
currency: _09e8c7918e9a(_91b3cb2ae904),
item_count: _91b3cb2ae904.item_count || 0,
subtotal_price: (_91b3cb2ae904.items_subtotal_price || 0) / 100,
total_price: (_91b3cb2ae904.total_price || 0) / 100,
shippingPrice: 0,
items: (_91b3cb2ae904.items || []).map(function (_b54a06f63d1b) {
return {
title: _b54a06f63d1b.product_title || _b54a06f63d1b.title || '\x50\x72\u006f\u0064\u0075\x63\u0074',
variant: _b54a06f63d1b.variant_title || '\x44\u0065\u0066\u0061\x75\u006c\u0074\u0020\u0054\u0069\u0074\x6c\x65',
quantity: _b54a06f63d1b.quantity || 1,
price: (_b54a06f63d1b.price || 0) / 100,
image: _b54a06f63d1b.image || '',
line_key: _b54a06f63d1b.key || '',
variant_id: _b54a06f63d1b.id || '',
product_id: _b54a06f63d1b.product_id || '',
product_title: _b54a06f63d1b.product_title || _b54a06f63d1b.title || '',
variant_title: _b54a06f63d1b.variant_title || '',
line_price: (_b54a06f63d1b.line_price || 0) / 100,
sku: _b54a06f63d1b.sku || '',
vendor: _b54a06f63d1b.vendor || ''
};
})
};
_8a9e366ccfa1(_e6823720c70c, _2385b16b60f5);
} catch (_686a1ea0bbe7) {
console.error('\x50\u0041\u0059\u0020\x44\u0045\u0042\u0055\u0047\x3a', _686a1ea0bbe7);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\x70\u0069\x66\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_686a1ea0bbe7 && _686a1ea0bbe7.message ? _686a1ea0bbe7.message : String(_686a1ea0bbe7))
);
_9757db2b2769.disabled = false;
_9757db2b2769.innerText = _08c8710dacb3;
}
},
true
);
})();
